import React from "react";
import Breadcrumb from "../components/Breadcrumb";

export default function DigitalMarketingStrategy() {
  return (
    <>
      <Breadcrumb title="Digital Marketing Strategy" />
      <div className="page-service-single">
        <div className="container">
          {/* Main Content */}
          <div className="row">
            <div className="col-lg-12">
              <div className="service-single-content">
                {/* Featured Image */}
                <div className="service-featured-image">
                  <figure className="image-anime reveal">
                    <img
                      src="./assets/images/managed.png"
                      alt="Managed Services"
                      loading="lazy"
                    />
                  </figure>
                </div>

                {/* Entry Content */}
                <div className="service-entry">
                  <p className="wow fadeInUp" data-wow-delay="0.25s">
                    We provide reliable digital operations support to ensure
                    uninterrupted business continuity. Our teams act as an
                    extension of your organization to manage, support, and
                    optimize digital environments.
                  </p>

                  <h4 className="mb-2">What we do</h4>
                  <ul>
                    <li>Technical support and troubleshooting</li>
                    <li>Platform monitoring and maintenance</li>
                    <li>Digital support for conferences and events</li>
                    <li>Ongoing optimization and issue resolution</li>
                  </ul>

                  <h4 className="mb-2 mt-2">Value we create</h4>
                  <ul>
                    <li>Reduced downtime and operational risk</li>
                    <li>Faster issue resolution</li>
                    <li>Smooth, reliable digital operations</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Sidebars */}
          <div className="row">
            <ServiceSidebar
              title="Platform & System Management"
              items={[
                "Website backend updates & maintenance",
                "CMS management (WordPress, Drupal, custom CMS)",
                "Mobile app support & updates",
                "API monitoring & error resolution",
                "Hosting, server, and cloud instance management",
                "Database management & optimization",
              ]}
            />

            <ServiceSidebar
              title="Digital Asset Operations"
              items={[
                "Managing digital content libraries",
                "Updating banners, visuals & product data",
                "Managing landing pages and campaign assets",
                "Tracking uptime & performance reports",
              ]}
            />

            <ServiceSidebar
              title="Process Automation & Workflow Support"
              items={[
                "CRM workflow automation",
                "Marketing automation (email journeys, triggers)",
                "Integration with ERP/CRM tools",
                "Dashboard creation & reporting",
              ]}
            />

            <ServiceSidebar
              title="User Support & Helpdesk"
              items={[
                "Tier 1, Tier 2 & Tier 3 support",
                "Ticketing system management (Freshdesk, Zendesk, Jira)",
                "Chat, email, and phone-based technical support",
                "Remote troubleshooting",
              ]}
            />

            <ServiceSidebar
              title="Security & IT Support"
              items={[
                "Malware detection & removal",
                "Firewall configuration & maintenance",
                "Access management (roles, password resets)",
              ]}
            />

            <ServiceSidebar
              title="Event Technical Support"
              items={[
                "Virtual event platform setup (Zoom, Teams, Webex)",
                "Webinar configuration & automation",
                "Live session troubleshooting",
                "Post-event analytics & reporting",
              ]}
            />
          </div>
        </div>
      </div>
    </>
  );
}
/* Reusable Sidebar Block */
function ServiceSidebar({ title, items }) {
  return (
    <div className="col-lg-4">
      <div className="service-sidebar">
        <div className="services-list-box wow fadeInUp" data-wow-delay="0.5s">
          <p>
            <strong>→ {title}</strong>
          </p>
          <ul>
            {items.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
